import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class TempGlueingService  {
  // private apiUrl = "http://localhost:3003/api/tempGlueing";
   private apiUrl = "https://lexipackghana.com:3003/api/tempGlueing";

  constructor(private http: HttpClient) {}
  addTempGlueing(data:any){
    return this.http.post(this.apiUrl+'/addTempGlueing',data);
  }
  getTempGlueing(){
    return this.http.get(this.apiUrl+'/getAllTempGlueing');
  }
  getTempGlueingById(id: string) {
    return this.http.get(this.apiUrl + '/' + id);
  }
  updateTempGlueing(id: string, data: any) {
    return this.http.put(this.apiUrl + '/' + id, data);
  }
}